import type { ProLayoutProps } from '@ant-design/pro-components';

const isProdB = process.env.REACT_APP_ENV === 'prod-b';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: isProdB ? '#FB7E7E' : '#1890ff',
  /**
   * 必须为 mix：pro-layout 在 layout=side 时 Header 直接不渲染（见 Header/index.js），
   * rightContentRender 只能画在侧栏底部；mix 才会渲染顶栏 GlobalHeader，用户信息在右上角。
   * splitMenus=false 保持一级菜单仍在左侧（不按 mix 分割到顶栏）。
   */
  layout: 'mix',
  splitMenus: false,
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: isProdB ? '医美管理' : '教育管理',
  pwa: true,
  logo: 'https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg',
  iconfontUrl: '',
  token: {
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
  },
};

export default Settings;
